var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-question",
      class: { edit: _vm.isSelected },
      on: { click: _vm.finish },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
        on: { click: _vm.stickerInstance.nextColor },
      }),
      _c(
        "div",
        {
          staticClass: "sticker sticker-question",
          class: [
            `color-${_vm.stickerInstance.data.color.slice(1).toUpperCase()}`,
          ],
          style: {
            backgroundColor: _vm.stickerInstance.data.color,
          },
        },
        [
          _c("div", { staticClass: "container-picture-image" }, [
            _c(
              "div",
              {
                staticClass: "picture-page",
                style: {
                  borderColor: _vm.stickerInstance.data.color,
                },
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      _vm.$attrs.pageSelected && _vm.$attrs.pageSelected.avatar
                        ? _vm.$attrs.pageSelected.avatar
                        : "img/avatar.jpg",
                  },
                }),
              ]
            ),
          ]),
          _c("div", { staticClass: "question-header" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.stickerInstance.data.question,
                  expression: "stickerInstance.data.question",
                },
              ],
              attrs: {
                cols: "20",
                rows: "2",
                wrap: "hard",
                maxlength: "100",
                placeholder: _vm.$t(
                  "dash.post-creator.story.question-placeholder"
                ),
                readonly: !_vm.isSelected,
              },
              domProps: { value: _vm.stickerInstance.data.question },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.stickerInstance.data,
                    "question",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _c("div", { staticClass: "fake-input" }, [
            _vm.isSelected
              ? _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.post-creator.story.question-people-answer")
                    )
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.post-creator.story.question-enter-something")
                    )
                  ),
                ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }